import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce211c68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar-left flex items-end p-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start ml-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl leading-none text-green-700" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Vue3"),
    /*#__PURE__*/_createTextVNode("-Charts ")
  ]),
  /*#__PURE__*/_createElementVNode("small", { class: "text-gray-500 leading-none" }, "v1.1.33")
], -1))
const _hoisted_4 = { class: "navbar-right flex items-center mr-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Docs ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/ghalex/vue3-charts",
  "aria-current": "page",
  class: "navbar-item"
}, " GitHub ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/ghalex/vue3-charts",
  class: "block ml-4"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://img.shields.io/github/stars/ghalex/vue3-charts.svg?style=social&label=Star",
    alt: "Github Stars"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " menu ", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Logo),
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/",
        "aria-current": "page",
        class: _normalizeClass(["navbar-item", { active: _ctx.route.name === 'home' }])
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        to: "/docs/getting-started",
        "aria-current": "page",
        class: _normalizeClass(["navbar-item", { active: _ctx.route.path.indexOf('/docs') > -1 }])
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["class"]),
      _hoisted_7,
      _hoisted_8
    ]),
    _createElementVNode("div", {
      class: "burger-menu",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSidebar = !_ctx.showSidebar))
    }, _hoisted_10)
  ]))
}